<template>
	<layout>
		<div v-if="branch_id">
			<pagetitle>Medewerkers {{ branch.title }}</pagetitle>
			<div class="row bg-white pt-3 pb-2 mb-5">
				<div class="col-4 col-md-3" v-for="(user, index) in branch.users" :key="index">
					<a 	:href="'/profile/'+user.id">
						<div class="card mb-2">
							<img class="card-img-top" :src="user.profile_image" :alt="user.firstname + ' '+ user.lastname">
							<div class="card-footer text-muted" v-html="user.firstname + ' '+ user.lastname">
							</div>
						</div>
					</a>
				</div>
			</div> 
		</div>
		<div v-else>
			<all-users></all-users>
		</div>
	</layout>
</template>

<script>
	import layout from '../layout/layout.vue'
	import users from '../components/users.vue'
	export default {

	  	name: 'users',
	  	props:{
			branch_id:{
				required: false
			},
		},
	  	components:{
			layout,
			'all-users' : users,
		},
	  	data () {
			return {
				branch : {},
			}
		},
		
		created(){
		    // window.console.log(JSON.parse(localStorage.getItem('user')));

		    // REQUESTING BRANCH DATA
		    if(this.branch_id){
				this.$store.dispatch("get",this.$store.state.endpoint+'branches/'+ this.branch_id+'?token='+this.$store.state.token)
			    // this.$store.dispatch("getBranch", this.$store.state.endpoint+"branches/"+this.branch_id+'?token='+this.$store.state.token)
			    .then(data=>{  
			        this.branch=data.data.data;
			        window.console.log('data',data); 
			       
			    }) 
			    .catch(error=>{
			        if(error.request.status == 401){
			            this.error=true;
			            this.error_msg="invalid login details";
			        }
			        // window.console.log(error.request.response);
			        
			    });
		    }
		}
	}
</script>

<style lang="css" scoped>
</style>